import { useState } from "react";

// Pick a Rinkel user from the live list (name + e-mail), with a manual ID as fallback.
export function RinkelIdField({ value, onChange, rinkelUsers, testid }) {
  const [manual, setManual] = useState(false);
  const linked = rinkelUsers.find((r) => r.id === value);
  if (rinkelUsers.length === 0 || manual) {
    return (
      <div className="flex items-center gap-1">
        <input data-testid={`${testid}-input`} value={value || ""} onChange={(e) => onChange(e.target.value)} className="fe-input w-40" placeholder="Rinkel-gebruikers-ID" title="Rinkel user-id voor telefonie" />
        {rinkelUsers.length > 0 && <button data-testid={`${testid}-to-list`} onClick={() => setManual(false)} className="text-xs text-[#001C51] underline px-1">Lijst</button>}
      </div>
    );
  }
  return (
    <select data-testid={`${testid}-select`} value={value || ""} className="fe-input w-64" title={linked ? `${linked.name} (${linked.email})` : ""}
      onChange={(e) => (e.target.value === "__manual" ? setManual(true) : onChange(e.target.value))}>
      <option value="">— Geen Rinkel-account —</option>
      {value && !linked && <option value={value}>Onbekend Rinkel-account ({value})</option>}
      {rinkelUsers.map((r) => <option key={r.id} value={r.id}>{r.name}{r.email ? ` (${r.email})` : ""}</option>)}
      <option value="__manual">Handmatig ID invullen…</option>
    </select>
  );
}
